import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountNaicsCodesQueryKey } from "../account.keys";

export const useUpdateAccountNaicsCodes = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		mutationFn: (body: Dtos.NaicsCode.Update.Request) =>
			put(`/v2/surety/accounts/${accountId}/naics-codes`, body, "none"),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountNaicsCodesQueryKey(accountId) });
		},
	});

	return {
		updateAccountNaicsCodes: mutation.mutate,
		updateAccountNaicsCodesError: mutation.error,
		updateAccountNaicsCodesIsLoading: mutation.isPending,
	};
};
